// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"ArticleMiniGroup_titleWrapper__BjtHF","articlesWrapper":"ArticleMiniGroup_articlesWrapper__MxZDI"};